(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dhl-wunschtag"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dhl-wunschtag')) {
    customElements.define(
      'dhl-wunschtag',
      class DhlWunschtag extends HTMLElement {
        connectedCallback() {
          this.checkbox = this.querySelector('.dhl-wunschtag__checkbox');
          this.datePanel = this.querySelector('.dhl-wunschtag__date');
          this.dateInput = this.querySelector('.dhl-wunschtag__date-input');
          this.status = this.querySelector('.dhl-wunschtag__status');
          this.updating = false;

          if (!this.checkbox || !this.dateInput) return;

          const today = this.berlinToday();
          this.minimumDate = this.addDays(today, 6);
          this.dateInput.min = this.toIso(this.minimumDate);
          this.dateInput.value = this.displayToIso(this.dataset.selectedDate);
          this.propertyLabel = this.dataset.propertyLabel || 'Gewünschter Liefertag';
          this.storedPropertyLabel = this.dataset.storedPropertyLabel || '';
          this.shippingNoticeLabel = this.dataset.shippingNoticeLabel || 'Versandhinweis';
          this.shippingNotice = this.dataset.shippingNotice || 'Nicht mit Express kombinierbar.';
          this.shippingNoticeCurrent = this.dataset.shippingNoticeCurrent === 'true';

          if (this.dateInput.value && !this.validDate(this.dateInput.value)) {
            this.dateInput.value = '';
            this.showStatus(this.dataset.invalidMessage);
          }

          this.handleToggle = this.onToggle.bind(this);
          this.handleDateChange = this.onDateChange.bind(this);
          this.handleCheckout = this.onCheckout.bind(this);
          this.checkbox.addEventListener('change', this.handleToggle);
          this.dateInput.addEventListener('change', this.handleDateChange);
          document.addEventListener('click', this.handleCheckout, true);

          if (
            this.dataset.lineKey &&
            this.dateInput.value &&
            (this.storedPropertyLabel !== this.propertyLabel || !this.shippingNoticeCurrent)
          ) {
            void this.saveService(this.isoToDisplay(this.dateInput.value));
          }

          if (Number(this.dataset.regularItemCount) === 0 && this.dataset.lineKey) {
            this.removeService();
          }
        }

        disconnectedCallback() {
          this.checkbox?.removeEventListener('change', this.handleToggle);
          this.dateInput?.removeEventListener('change', this.handleDateChange);
          document.removeEventListener('click', this.handleCheckout, true);
        }

        berlinToday() {
          const parts = new Intl.DateTimeFormat('en-CA', {
            timeZone: 'Europe/Berlin',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).formatToParts(new Date());
          const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
          return new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day), 12));
        }

        addDays(date, days) {
          const result = new Date(date);
          result.setUTCDate(result.getUTCDate() + days);
          return result;
        }

        toIso(date) {
          return date.toISOString().slice(0, 10);
        }

        displayToIso(value) {
          const match = String(value || '').match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
          return match ? `${match[3]}-${match[2]}-${match[1]}` : '';
        }

        isoToDisplay(value) {
          const [year, month, day] = value.split('-');
          return `${day}.${month}.${year}`;
        }

        validDate(value) {
          if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
          if (value < this.dateInput.min) return false;
          return new Date(`${value}T12:00:00Z`).getUTCDay() !== 0;
        }

        async onToggle() {
          this.clearStatus();
          this.datePanel.hidden = !this.checkbox.checked;

          if (this.checkbox.checked) {
            this.dateInput.focus();
            return;
          }

          this.dateInput.value = '';
          if (this.dataset.lineKey) await this.removeService();
        }

        async onDateChange() {
          this.clearStatus();

          if (!this.validDate(this.dateInput.value)) {
            this.showStatus(this.dataset.invalidMessage);
            this.dateInput.value = '';
            this.dateInput.focus();
            return;
          }

          await this.saveService(this.isoToDisplay(this.dateInput.value));
        }

        onCheckout(event) {
          if (!(event.target instanceof Element)) return;
          const checkoutButton = event.target.closest('button[name="checkout"], #CartDrawer-Checkout');
          if (!checkoutButton || !this.checkbox.checked) return;

          if (this.updating || !this.validDate(this.dateInput.value) || !this.dataset.lineKey) {
            event.preventDefault();
            event.stopImmediatePropagation();
            this.showStatus(this.updating ? this.dataset.loadingMessage : this.dataset.requiredMessage);
            this.datePanel.hidden = false;
            this.dateInput.focus();
          }
        }

        async saveService(displayDate) {
          this.setBusy(true);
          const properties = {
            [this.propertyLabel]: displayDate,
            [this.shippingNoticeLabel]: this.shippingNotice,
          };

          try {
            if (this.dataset.lineKey) {
              await this.updateCart('cart/change.js', {
                id: this.dataset.lineKey,
                quantity: 1,
                properties,
              });
            } else {
              await this.updateCart('cart/add.js', {
                items: [
                  {
                    id: Number(this.dataset.variantId),
                    quantity: 1,
                    properties,
                  },
                ],
              });
            }
          } catch (error) {
            this.setBusy(false);
            this.showStatus(this.dataset.errorMessage);
          }
        }

        async removeService() {
          if (!this.dataset.lineKey || this.updating) return;
          this.setBusy(true);

          try {
            await this.updateCart('cart/change.js', {
              id: this.dataset.lineKey,
              quantity: 0,
            });
          } catch (error) {
            this.setBusy(false);
            this.checkbox.checked = true;
            this.datePanel.hidden = false;
            this.showStatus(this.dataset.errorMessage);
          }
        }

        async updateCart(endpoint, payload) {
          const response = await fetch(`${window.Shopify.routes.root}${endpoint}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              ...payload,
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          });

          const state = await response.json();
          if (!response.ok) throw new Error(state.description || 'Cart update failed');

          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
            drawer.renderContents(state);
            return;
          }

          window.location.reload();
        }

        setBusy(busy) {
          this.updating = busy;
          this.setAttribute('aria-busy', String(busy));
          this.checkbox.disabled = busy;
          this.dateInput.disabled = busy;
          if (busy) this.showStatus(this.dataset.loadingMessage);
        }

        showStatus(message) {
          this.status.textContent = message;
          this.status.hidden = false;
        }

        clearStatus() {
          this.status.textContent = '';
          this.status.hidden = true;
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
